import { Button, Group } from '@vipso/shared';

export interface ModalFooterProps {
  onCancel: () => void;
  onSubmit: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  disabled?: boolean;
}

/** Right-aligned Cancel + primary action row used by the admin modals. */
export function ModalFooter({
  onCancel,
  onSubmit,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  loading,
  disabled,
}: ModalFooterProps) {
  return (
    <Group justify="flex-end">
      <Button variant="default" onClick={onCancel}>
        {cancelLabel}
      </Button>
      <Button loading={loading} disabled={disabled} onClick={onSubmit}>
        {submitLabel}
      </Button>
    </Group>
  );
}
